import View from './View';
export default View;
//# sourceMappingURL=index.js.map